<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="38"
    viewBox="0 0 30 38"
    fill="none"
  >
    <path
      d="M11.4697 19.2319C11.7626 18.9227 12.2375 18.9227 12.5304 19.2319L18.5304 25.5652C18.7449 25.7916 18.8091 26.1321 18.693 26.428C18.5769 26.7238 18.3034 26.9166 18 26.9166H14.25V37.2083C14.25 37.6455 13.9143 38 13.5 38H10.5C10.0858 38 9.75004 37.6455 9.75004 37.2083V26.9166H6.00004C5.69666 26.9166 5.42321 26.7238 5.30711 26.428C5.19101 26.1321 5.25521 25.7916 5.46971 25.5652L11.4697 19.2319Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.5 0H3.04286H10.7571H16.1571H20.25L23.748 3.67531L26.5605 6.52531L30 9.88V12.9355V17.9298V22.9241V27.9184V32.9127V36.48C30 37.3195 29.3284 38 28.5 38H26.9571H21.5571H17.25V36.48H21.5571H26.9571H28.5V32.9127V27.9184V22.9241V17.9298V12.1756H22.6071L19.5 12.16C18.6716 12.16 18 11.4795 18 10.64V7.07265V1.52H10.7571H3.04286L1.5 1.52V5.08735V10.0816V15.0759V20.0702V25.0645V30.0588V35.0531L1.5 36.48H5.35714H7.125V38H5.3572H1.5C0.671573 38 0 37.3195 0 36.48V35.0531V30.0588V25.0645V20.0702V15.0759V10.0816V5.08735V1.52C0 0.680528 0.671573 0 1.5 0ZM22.6874 4.75012L19.5 1.52V7.07265V10.64L22.6071 10.6556L28.5 10.64L25.4999 7.60011L22.6874 4.75012Z"
    />
  </svg>
</template>
